module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a class="remove-col" href="#">\n  <img src="/static/images/icon-trash.gif" />\n</a>\n<input type="text" class="edit" name="columns" maxlength="150" value="'+
((__t=( description ))==null?'':_.escape(__t))+
'" />\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./menupicker/templates/col.html
// module id = 268
// module chunks = 0